/**
 * vLLM Bangkok, the community AGICAFET organizes. The facts follow what
 * vllmbangkok.com itself says (2026-10-04): "The Thai community around vLLM,
 * organised by AGICAFET", "a directory of the teams running vLLM in
 * production", and its flagship day "talks from vLLM maintainers, Thai
 * production stories, two panels". The AI inference / infrastructure framing
 * is the owner's (2026-10-04). No size claim ("largest") and no attendee or
 * member numbers until the owner supplies them.
 */
export const COMMUNITY = {
  name: 'vLLM Bangkok',
  url: 'https://vllmbangkok.com/',
  host: 'vllmbangkok.com',
  line:
    'The Thai community around vLLM, the open-source engine that serves large models fast, for the people who build AI inference and infrastructure. A flagship day with the vLLM maintainers, meetups and conference recaps in between, and a directory of the teams running vLLM in production.',
  event: {
    alt: 'Speakers and organizers on stage at vLLM Bangkok Day 2026',
    caption:
      'vLLM Bangkok Day 2026, 6 September at JAS Green Village Ramkhamhaeng: talks from vLLM maintainers, Thai production stories and two panels.',
  },
} as const;
